import { StandardEvents } from '@shopify/events';

/**
 * Keeps Hour & Heir price displays in step with the selected variant.
 *
 * When the shopper picks another variant (for example a new finish), Horizon
 * fetches the product section again and hands the new HTML to listeners of
 * the product-select event. Every element in that section marked
 * `data-hh-refresh="<key>"` is then swapped for its copy from the new HTML.
 *
 * Fires `hh:variant-refresh` (bubbles) on the section afterwards, with
 * `{ html, variant }` in `detail`, so other Hour & Heir pieces (the set
 * picker) can update themselves too.
 */
if (!window.hhVariantRefreshReady) {
  window.hhVariantRefreshReady = true;

  document.addEventListener(StandardEvents.productSelect, (event) => {
    const source = event.target;
    if (!(source instanceof Element) || source.closest('product-card')) return;

    const section = source.closest('.shopify-section');
    if (!section) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!(html instanceof Document)) return;

        for (const element of section.querySelectorAll('[data-hh-refresh]')) {
          if (!(element instanceof HTMLElement)) continue;
          const key = CSS.escape(element.dataset.hhRefresh ?? '');
          const fresh = html.querySelector(`[data-hh-refresh="${key}"]`);
          if (fresh) element.replaceWith(document.importNode(fresh, true));
        }

        // Shopify's installments message follows the variant in its form.
        const variantId = detail.resource?.id;
        if (variantId) {
          for (const input of section.querySelectorAll('form.hh-payment-terms input[name="id"]')) {
            if (!(input instanceof HTMLInputElement) || input.value === String(variantId)) continue;
            input.value = String(variantId);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        section.dispatchEvent(
          new CustomEvent('hh:variant-refresh', { bubbles: true, detail: { html, variant: detail.resource ?? null } })
        );
      })
      .catch(() => {
        // Aborted by a newer selection; that request will refresh the prices.
      });
  });
}
